(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemManageTranslationsEdit", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/general/languages/learningItems/learningItemManageTranslationsEditView.html",
            controller: ["learningItemTranslationsService", "_", "learningItemLocalizationResource", "notify", "$rootScope", "$state", "$stateParams", "$localStorage", "$translate", LearningItemManageTranslationsEditCtrl],
            controllerAs: "vm"
        };
        function LearningItemManageTranslationsEditCtrl(learningItemTranslationsService, _, learningItemLocalizationResource, notify, $rootScope, $state, $stateParams, $localStorage, $translate) {
            var vm = this;
            vm.tenantEnabledLocalizations = [];
            vm.goBack = goBack;
            vm.toggleTranslated = toggleTranslated;
            vm.changeLocalization = changeLocalization;
            vm.tenantDefaultLocalizationId = $localStorage.tenantSettings.defaultLocalization.id;
            vm.saveLearningItemTranslations = saveLearningItemTranslations;
            vm.saveLearningItemTranslationsAndReturn = saveLearningItemTranslationsAndReturn;
            vm.isAllLanguagesValid = isAllLanguagesValid;
            vm.isValid = false;
            var lang = $translate.proposedLanguage() || $translate.use();
            lang = lang.replace("-", "_");
            vm.tinymceInlineOptions = {
                menubar: false,
                resize: true,
                inline: true,
                height: 200,
                plugins: "code, paste, textcolor, autoresize, link",
                toolbar: "bold italic underline strikethrough superscript subscript | forecolor backcolor | undo bullist numlist | link",
                default_link_target: "_blank",
                language: lang,
                setup: function (editor) {
                    editor.on("init", function () {
                        // Default classes of tinyMCE are a bit weird
                        // I add my own class on init
                        // this also sets the empty class on the editor on init
                        if (editor.getContent() === "")
                            window.tinymce.DOM.addClass(editor.bodyElement, "content-editor empty");
                        else
                            window.tinymce.DOM.addClass(editor.bodyElement, "content-editor");
                    });
                    editor.on("focus", function () {
                        window.tinymce.DOM.removeClass(editor.bodyElement, "empty");
                    });
                    editor.on("blur", function () {
                        if (editor.getContent() === "") {
                            window.tinymce.DOM.addClass(editor.bodyElement, "empty");
                        }
                        else {
                            window.tinymce.DOM.removeClass(editor.bodyElement, "empty");
                        }
                    });
                }
            };
            loadLearningItem();
            function goBack() {
                if ($rootScope.fromState.name !== "")
                    $state.go($rootScope.fromState.name, $rootScope.fromParams);
                else
                    $state.go("main.learningItems.manageItemsTranslations");
            }
            function toggleTranslated(checkBoxValue) {
                vm.learningItemLocalizations[vm.indexPosition].isTranslated = !checkBoxValue;
            }
            function loadLearningItem() {
                var code = $stateParams.code;
                learningItemLocalizationResource.get({ code: code }, function (result) {
                    vm.learningItemTranslationSingleEntryViewModel = result;
                    vm.tenantEnabledLocalizations = angular.copy($localStorage.tenantSettings.enabledLocalizations);
                    //vm.tenantEnabledLocalizations = vm.learningItemTranslationSingleEntryViewModel.localizations;
                    vm.defaultLocalization = _.where(vm.tenantEnabledLocalizations, { id: vm.tenantDefaultLocalizationId })[0];
                    vm.tenantEnabledLocalizations = _.reject(vm.tenantEnabledLocalizations, { id: vm.tenantDefaultLocalizationId });
                    vm.defaultLearningItemLocalization = _.where(vm.learningItemTranslationSingleEntryViewModel.learningItemLocalizations, { localizationId: vm.tenantDefaultLocalizationId })[0];
                    vm.learningItemLocalizations = _.reject(vm.learningItemTranslationSingleEntryViewModel.learningItemLocalizations, { localizationId: vm.tenantDefaultLocalizationId });
                    vm.indexPosition = vm.learningItemLocalizations.indexOf(vm.learningItemLocalizations[0]);
                    vm.isValid = isAllLanguagesValid();
                });
            }
            function changeLocalization(localizationId) {
                vm.selectedLearningItemLocalization = _.where(vm.learningItemLocalizations, { localizationId: localizationId })[0];
                vm.indexPosition = vm.learningItemLocalizations.indexOf(vm.selectedLearningItemLocalization);
                vm.isValid = isAllLanguagesValid();
            }
            function saveLearningItemTranslations(isValid) {
                if (vm.isValid) {
                    learningItemTranslationsService.updateLearningItemLocalizations(vm.learningItemLocalizations).then(function (result) {
                        vm.learningItemTranslationSingleEntryViewModel = result.data;
                        vm.learningItemLocalizations = _.reject(vm.learningItemTranslationSingleEntryViewModel.learningItemLocalizations, { localizationId: vm.tenantDefaultLocalizationId });
                        notify({ messageTemplate: "<span>{{ 'translations.singleEntry.successMessage' | translate }}</span>", classes: "alert-success" });
                    }, function () {
                        notify({ messageTemplate: "<span>{{ 'common.genericError' | translate }}</span>", classes: "alert-danger" });
                    });
                }
            }
            function saveLearningItemTranslationsAndReturn(isValid) {
                if (vm.isValid) {
                    learningItemTranslationsService.updateLearningItemLocalizations(vm.learningItemLocalizations).then(function () {
                        notify({ messageTemplate: "<span>{{ 'translations.singleEntry.successMessage' | translate }}</span>", classes: "alert-success" });
                        vm.goBack();
                    }, function () {
                        notify({ messageTemplate: "<span>{{ 'common.genericError' | translate }}</span>", classes: "alert-danger" });
                    });
                }
            }
            function isAllLanguagesValid() {
                return _.every(vm.learningItemLocalizations, function (item) {
                    return (item.name && item.name != '') &&
                        (item.description && item.description != '');
                });
            }
        }
    });
})();
